import { render, staticRenderFns } from "./OfficeInfo.vue?vue&type=template&id=005504ee&scoped=true&"
import script from "./OfficeInfo.vue?vue&type=script&lang=ts&"
export * from "./OfficeInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeInfo.vue?vue&type=style&index=0&id=005504ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005504ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardText,VCardTitle,VRow,VSimpleTable,VSubheader})
